import { useState, useEffect } from "react";
import { useReportDateRange } from "./useReportDateRange";

export const usePITDateFilter = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading] = useState(false);
  const [error] = useState(null);
  
  const { startDate: globalStartDate, endDate: globalEndDate } = useReportDateRange();

  useEffect(() => {
    if (globalStartDate && globalEndDate) {
      setStartDate(globalStartDate);
      setEndDate(globalEndDate);
    }
  }, [globalStartDate, globalEndDate]);

  const updateDateRange = (newStartDate, newEndDate) => {
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const clearDateRange = () => {
    setStartDate(null);
    setEndDate(null);
  };

  const getCurrentDateRange = () => {
    return {
      startDate: startDate || globalStartDate,
      endDate: endDate || globalEndDate
    };
  };

  return {
    startDate,
    endDate,
    loading,
    error,
    updateDateRange,
    clearDateRange,
    getCurrentDateRange
  };
}; 